import { render, staticRenderFns } from "./SendCode.vue?vue&type=template&id=68fff051&scoped=true"
import script from "./SendCode.vue?vue&type=script&lang=js"
export * from "./SendCode.vue?vue&type=script&lang=js"
import style0 from "./SendCode.vue?vue&type=style&index=0&id=68fff051&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.30_cache-loader@4.1.0_webpack@4.46.0__css-load_ecc709542230bcceb67dd6366ef941ae/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fff051",
  null
  
)

export default component.exports